import { getData, postData, convertPageModel, getFileData } from './api-base.service'

export const getCourseHomeworkList = (model) => {
  let data = convertPageModel(model);
  return postData('/Homework/GetCourseHomeworkList', data);
}

export const downloadHomework = (model) => {
  let data = convertPageModel(model);
  return getFileData('/Homework/DownloadHomework', data, false);
}

export const getStudentHomeworkFileList = (studentHomeworkId) => {
  let data = { studentHomeworkId: studentHomeworkId };
  return getData('/Homework/GetStudentHomeworkFileList', data);
}

export const deleteStudentHomeworkFile = (fileId) => {
  let data = { fileId: fileId };
  return getData('/Homework/DeleteStudentHomeworkFile', data);
}

export const saveStudentHomeworkFile = (studentHomeworkId, fileStorageId) => {
  let data = {
    StudentHomeworkId: studentHomeworkId,
    FileStorageId: fileStorageId
  };
  return postData('/Homework/SaveStudentHomeworkFile', data);
}

export const getSpecificStudentHomeworkList = (studentId, courseId, campusId) => {
  let data = { studentId: studentId, courseId: courseId, campusId: campusId };
  return getData('/Homework/GetSpecificStudentHomeworkList', data);
}

export const getStudentHomeworkList = (homeworkId) => {
  let data = { homeworkId: homeworkId };
  return getData('/Homework/GetStudentHomeworkList', data);
}

export const getCourseHomeWorkDetailList = (courseId, campusId) => {
  let data = { courseId: courseId, campusId: campusId };
  var result = getData('/Homework/GetCourseHomeworkDetailList', data);
  return result;
}

export const getHomeworkTypes = () => {
  var result = getData('/Homework/GetHomeworkTypeList');
  return result;
}

export const getCourseActivations = (homeworkId, courseId, campusId, homeworkType) => {
  let data = { homeworkId: homeworkId, courseId: courseId, campusId: campusId, homeworkType: homeworkType };
  var result = getData('/Homework/GetCourseActivations', data);
  return result;
}

export const removeHomework = (id) => {
  let data = { id: id };
  var result = getData('/Homework/RemoveHomework', data);
  return result;
}

export const getHomework = (homeworkId) => {
  let data = { homeworkId: homeworkId };
  return getData('/Homework/GetCourseHomework', data);
}

export const getCourseHomeworkFileList = (homeworkId) => {
  let data = { homeworkId: homeworkId };
  return getData('/Homework/GetCourseHomeworkFileList', data);
}

export const saveHomework = (data) => {
  return postData('/Homework/SaveHomework', data);
}

export const markHomework = (studentHomeworkId, score) => {
  let data = { Id: studentHomeworkId, Score: score };
  return postData('/Homework/UpdateStudentHomeworkScore', data);
}

export const commentHomework = (studentHomeworkId, comments) => {
  let data = { Id: studentHomeworkId, Comment: comments };
  return postData('/Homework/UpdateStudentHomeworkComment', data);
}

export const updateStudentHomeworkIsCompleted = (studentHomeworkId, isCompleted) => {
  let data = { Id: studentHomeworkId, IsCompleted: isCompleted };
  return postData('/Homework/UpdateStudentHomeworkIsCompleted', data);
}

export const getCourseHomeworkDetail = (id) => {
  let data = { id: id };
  return getData('/Homework/GetCourseHomeworkDetail', data);
}

export const getCourseHomeworkStatistic = (id) => {
  let data = { id: id };
  return getData('/Homework/GetCourseHomeworkStatistic', data);
}

export const getStudentHomework = (homeworkId, studentHomeworkId) => {
  let data = { homeworkId: homeworkId, studentHomeworkId: studentHomeworkId };
  return getData('/Homework/GetStudentHomework', data);
}

export const getTotalFilesInfo = (model) => {
  let data = convertPageModel(model);
  return postData('/Homework/GetTotalFilesInfo', data);
}



// WEBPACK FOOTER //
// ./src/service/homework.service.js